import { type FC } from 'react'
import { type TeamChipKey } from './teamChips'

const TEAM_EMPTY_STATES: Record<TeamChipKey, { title: string; subtitle: string }> = {
  active: { title: 'No active members yet', subtitle: 'Invite your team to start using Zocks together.' },
  pending: { title: 'No pending invitations', subtitle: 'Invited users appear here until they accept.' },
  expired: { title: 'No expired invitations', subtitle: "Invitations that weren't accepted in time appear here." },
  requested: { title: 'No requested invitations', subtitle: 'Invitations waiting for a free seat appear here.' },
  deactivated: { title: 'No deactivated members', subtitle: 'Deactivated members appear here. Their data is kept.' },
}

export interface TeamEmptyStateProps {
  chip: TeamChipKey
}

export const TeamEmptyState: FC<TeamEmptyStateProps> = ({ chip }) => (
  <div className='d-flex flex-column align-items-center gap-2 py-4 text-center zocks-text-gray-900'>
    <h5 className='mb-0'>{TEAM_EMPTY_STATES[chip].title}</h5>
    <div className='paragraph-medium mb-0'>{TEAM_EMPTY_STATES[chip].subtitle}</div>
  </div>
)
